import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NzTableModule} from "ng-zorro-antd/table";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzPopconfirmModule} from "ng-zorro-antd/popconfirm";
import {NzPipesModule} from "ng-zorro-antd/pipes";
import {DocumentService} from "../../../@core/document.service";
import {AimsFile} from '../model';

@Component({
  selector: 'app-file-list',
  standalone: true,
  imports: [CommonModule, NzTableModule, NzButtonModule, NzPopconfirmModule, NzPipesModule],
  template: `
    <ng-container *ngIf="fileList.length">
      <p *ngIf="title"><strong>{{title}}</strong></p>
      <nz-table nzBordered="true" nzSize="small" nzTemplateMode style="margin: 10px 0;">
        <thead>
        <tr>
          <th>Name</th>
          <th>Size</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let f of fileList; index as i">
          <td>{{f.name}}</td>
          <td>{{f.size | nzBytes}}</td>
          <td>
            <button
              nz-button type="button"
              nzSize="small" (click)="viewDoc(f)">View
            </button>
            <button *ngIf="!viewMode" (click)="deleteChild(i)" nz-button
                    type="button"
                    nz-popconfirm="" nzPopconfirmPlacement="bottom"
                    nzPopconfirmTitle="Are you sure to delete?"
                    nzSize="small" nzDanger>Delete
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
    </ng-container>
  `,
  styles: [`
    button {
      margin-left: 5px
    }
  `]

})
export class FileListComponent implements OnInit {
  @Input() fileList: AimsFile[] = [];
  @Input() viewMode = false;
  @Output() updateFileList = new EventEmitter<AimsFile[]>();
  title = '';


  constructor(private doc: DocumentService) {
  }


  ngOnInit(): void {
    if (!Array.isArray(this.fileList)) {
      throw new Error('File list must be array');
    }
    if (this.viewMode) {
      this.title = 'Uploaded Supporting';
    }
  }

  deleteChild(index: number) {
    // if (this.fileList[index].path) {
    //   this.fileList[index].deleted = true;
    //   this.fileList = this.fileList.filter(f => !f.deleted);
    // } else {
    //   this.fileList.splice(index, 1);
    // }
    this.fileList.splice(index, 1);
    this.updateFileList.emit(this.fileList);
  }


  viewDoc(f: AimsFile) {
    if (f.uploadStatus === 'pending') {
      const url = URL.createObjectURL(f._raw as any);
      window.open(url);
      return;
    }
    if (f.path) {
      this.doc.viewDoc(f.path!)
        .subscribe((blob) => {
          const url = URL.createObjectURL(blob);
          window.open(url);
        });
    }

  }

}
